export const MODAL_ADDED_TO_CART = 'addedToCart'
export const MODAL_ASK_SPECIALIST = 'askSpecialist'
export const MODAL_CONTENT = 'content'
export const MODAL_SEND_PRODUCT_REVIEW = 'sendProductReview'
export const MODAL_POCKET_PRODUCTS = 'pocketProducts'
export const MODAL_VACANCY = 'vacancy'
export const MODAL_VACANCY_RESUME = 'vacancyResume'
